import { RequestError, RequestErrorType } from './generic-errors';
import { ConnectSuite } from './connect-suite.type';

export function checkMembershipErrorsConnectSuitSystem(
  error: ConnectSuite.ExecuteMembershipError | null,
  validateObject: any,
) {
  if (error?.responseCode === '037' && error.responseText.startsWith('This membership has reached')) {
    throw new RequestError(RequestErrorType.MembershipAddAssociateReachMaximumNumberOfAssociates, validateObject);
  }
}
